import { roundDownToNearestThousand, roundUpToNearestThousand } from '../../../../../utils/helpers';

import { MaFilterKeys } from '../constants';
import { isNumber } from '../../../../../utils/helpers';
import { useEffect } from 'react';
import { useGetFiltersSummary } from './useGetFiltersSummary';
import { useMaOpportunitiesContext } from '../../../MaOpportunitiesContext';

/**
 * Hook to update the FiltersContext with the available slider ranges based on the data returned from the GraphQL query.
 * This is needed to allow us to reset the slider values when the user clears the filters.
 *
 * @returns
 */
export const useUpdateFilterRanges = () => {
  const { data, loading } = useGetFiltersSummary();
  const { setFilters, setValuationRange, setReservesRange, setProductionRange, setEmissionsRange } =
    useMaOpportunitiesContext();

  useEffect(() => {
    if (loading || !data) return;

    if (isNumber(data?.minValuation) && isNumber(data?.maxValuation)) {
      const valuationRange = [
        roundDownToNearestThousand(data.minValuation),
        roundUpToNearestThousand(data.maxValuation),
      ];
      setValuationRange(valuationRange);
      setFilters((prevFilters) => ({ ...prevFilters, [MaFilterKeys.valuation]: valuationRange }));
    }

    if (isNumber(data?.minReserves) && isNumber(data?.maxReserves)) {
      const reservesRange = [
        roundDownToNearestThousand(data.minReserves),
        roundUpToNearestThousand(data.maxReserves),
      ];
      setReservesRange(reservesRange);
      setFilters((prevFilters) => ({ ...prevFilters, [MaFilterKeys.reserves]: reservesRange }));
    }

    if (isNumber(data?.minProduction) && isNumber(data?.maxProduction)) {
      const productionRange = [
        roundDownToNearestThousand(data.minProduction),
        roundUpToNearestThousand(data.maxProduction),
      ];
      setProductionRange(productionRange);
      setFilters((prevFilters) => ({ ...prevFilters, [MaFilterKeys.production]: productionRange }));
    }

    if (isNumber(data?.minEmissions) && isNumber(data?.maxEmissions)) {
      const emissionsRange = [
        roundDownToNearestThousand(data.minEmissions),
        roundUpToNearestThousand(data.maxEmissions),
      ];
      setEmissionsRange(emissionsRange);
      setFilters((prevFilters) => ({ ...prevFilters, [MaFilterKeys.emissions]: emissionsRange }));
    }
  }, [data, loading]);

  return null;
};
